import { render, staticRenderFns } from "./InventorySkillCard.vue?vue&type=template&id=4add129e&"
import script from "./InventorySkillCard.vue?vue&type=script&lang=js&"
export * from "./InventorySkillCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports